import type { WatermarksState } from './types';

export const initialState: WatermarksState = {
  watermarkSets: null,
  currentWatermarkSet: null,
  loading: false,
  error: false,
};
